module.exports = __webpack_public_path__ + "img/no_result.b21aade7.png";